const feedbackMessageTypes = {
    company: 1,
    feedbackUser: 2
}

export default feedbackMessageTypes;

